import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  ACCESS_TOKEN,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  loggedIn: false,
  accessToken: "",
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        loggedIn: true,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = {
        loggedIn: false,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case ACCESS_TOKEN:
      state = { ...state, accessToken: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
